import { useApolloClient } from '@apollo/client'
import { LogOut } from 'lucide-react'
import { useRouter } from 'next/navigation'

import { doLogoutAction } from '@/actions/auth'
import { STORAGE_REFRESH_TOKEN_KEY, STORAGE_TOKEN_KEY, STORAGE_UID_KEY } from '@/constants'
import { useTranslation } from '@/i18n/client'
import { updateLocalToken } from '@/service/token'

type Props = {
  login: string
}

function LogoutButton({ login }: Props) {
  const { t } = useTranslation()
  const ac = useApolloClient()
  const router = useRouter()
  return (
    <button
      className='flex w-full items-center gap-2 rounded-lg px-3 py-2 text-red-400 transition-colors hover:bg-gray-700/50'
      onClick={async () => {
        updateLocalToken('')
        localStorage.removeItem(STORAGE_TOKEN_KEY)
        localStorage.removeItem(STORAGE_REFRESH_TOKEN_KEY)
        localStorage.removeItem(STORAGE_UID_KEY)
        await doLogoutAction()
        ac.resetStore()
        router.push(`/users/${login}`)
      }}
    >
      <LogOut className='h-4 w-4' />
      {t('nav.user.logout')}
    </button>
  )
}

export default LogoutButton